import type { ButtonHTMLAttributes } from 'react';
import { t } from '@/i18n';
import styles from './BackButton.module.css';

export function BackButton({
  children = (
    <>
      <span aria-hidden>←</span> {t.common.back}
    </>
  ),
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      className={[styles.bk, className].filter(Boolean).join(' ')}
      {...props}
    >
      {children}
    </button>
  );
}
